import { Component, Input } from '@angular/core';

import { VideogularComponent } from '../Videogular.Component';

import styles from './VgSkipChapter.module.less';

@Component({
	selector: 'vg-skip-chapter',
	host: {
		'[class]': 'styles.root'
	},
	template: `
		<button
			type="button"
			class="vb-icon-skip"
			[attr.aria-label]="translations.nextChapter"
			[ngClass]="styles.button"
			[tooltip]="translations.nextChapter"
			[placement]="'top'"
			(click)="vgApi.nextChapter()">
		</button>
	`
})
export class VgSkipChapterComponent {
	@Input() public translations: any;

	public readonly styles = styles;

	constructor(
		public vgApi: VideogularComponent
	) { }


}
